import { Trans } from '@lingui/react/macro';
import { Switch } from '@repo/videa-components/src/ui/switch';
import { useSetAtom } from 'jotai';

import type { PreferenceUpdateBody } from '@/@types/preferences';
import { VideaTypography } from '@/common-components/elements/VideaTypography/VideaTypography';
import { showSegmentationAtom } from '@/modules/annotator/multiFileViewer/imageToolbar/atoms';
import {
  usePreferences,
  usePreferencesUserUpdate,
} from '@/react-query/usePreferences';
import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

export const SegmentationPreferenceSettingsToggle = () => {
  const setShowSegmentation = useSetAtom(showSegmentationAtom);

  const { data: preferences } = usePreferences();
  const preferencesUpdateMutation = usePreferencesUserUpdate();
  const { trackEvent } = useTrackEvent();

  const preferencesUpdate = (update: PreferenceUpdateBody) => {
    preferencesUpdateMutation.mutate(update);
  };

  const handleToggle = (value: boolean) => {
    if (!preferences?.saveSegmentationViewEnabled) {
      return;
    }
    preferencesUpdate({ showSegmentationView: value });
    setShowSegmentation(value);
    trackEvent(mixpanelEvents.segmentationViewToggle, {
      segmentationViewToggle: value,
    });
  };

  return (
    <>
      <Switch
        checked={preferences?.showSegmentationView}
        onCheckedChange={handleToggle}
      />

      <VideaTypography className="pref-label" variant="labelSmall">
        <Trans>Default to Patient View</Trans>
      </VideaTypography>
    </>
  );
};
